import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { FaTools } from "react-icons/fa";

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-gray-50 p-4 dark:bg-gray-900">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="flex max-w-md flex-col items-center text-center"
      >
        <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400">
          <FaTools className="h-12 w-12" />
        </div>
        <h1 className="mb-4 text-h2 font-bold text-gray-900 dark:text-white">
          {t("maintenance.title", "System Under Maintenance")}
        </h1>
        <p className="mb-8 text-body-lg text-gray-600 dark:text-gray-300">
          {t(
            "maintenance.description",
            "We are currently performing scheduled maintenance. Please check back later.",
          )}
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-lg bg-blue-600 px-6 py-3 text-body font-medium text-white shadow-lg transition-colors hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          {t("refresh")}
        </button>

        <div className="mt-8 text-body-sm text-gray-500 dark:text-gray-400">
          <a
            href="/login"
            className="hover:text-blue-600 hover:underline dark:hover:text-blue-400"
          >
            {t("adminLogin", "Admin Login")}
          </a>
        </div>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;
